import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getDatabase, get, ref } from 'firebase/database';
import { ClipboardList } from 'lucide-react';
import { WORK_ORDER_LABELS as L } from '../../WorkOrders/workOrderSections';

const titleCache = new Map<string, Promise<string | null>>();

/** The work order's title, active or archived (cached per key for the session). */
const loadTitle = (workOrderKey: string): Promise<string | null> => {
    let pending = titleCache.get(workOrderKey);
    if (!pending) {
        pending = (async () => {
            for (const root of ['active', 'archive']) {
                const snapshot = await get(ref(getDatabase(), `workOrders/${root}/${workOrderKey}/title`));
                if (typeof snapshot.val() === 'string') return snapshot.val() as string;
            }
            return null;
        })().catch(() => null);
        titleCache.set(workOrderKey, pending);
    }
    return pending;
};

interface SourceWorkOrderBadgeProps {
    workOrderKey: string;
}

/** "Från ärende: <title>" on an issue reported from a work order, linking to it. */
const SourceWorkOrderBadge: React.FC<SourceWorkOrderBadgeProps> = ({ workOrderKey }) => {
    const [title, setTitle] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        void loadTitle(workOrderKey).then((t) => { if (!cancelled) setTitle(t); });
        return () => { cancelled = true; };
    }, [workOrderKey]);

    return (
        <Link
            to={`/management?wo=${encodeURIComponent(workOrderKey)}`}
            className="small d-inline-flex align-items-center gap-1"
            onClick={(e) => e.stopPropagation()}
        >
            <ClipboardList size={12} />
            {L.fromWorkOrder}: {title ?? 'Ärende'}
        </Link>
    );
};

export default SourceWorkOrderBadge;
